import { fetchAttachedCard } from '../../api/paymentApi';

const GET_ATTACHED_CARD = 'efes/contractSubscription/GET_ATTACHED_CARD';
const GET_ATTACHED_CARD_SUCCESS = 'efes/contractSubscription/GET_ATTACHED_CARD_SUCCESS';
const GET_ATTACHED_CARD_FAIL = 'efes/contractSubscription/GET_ATTACHED_CARD_FAIL';

const initialState = {
  attachedCard: null,
  attachedCardError: null,
  loadingAttachedCard: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_ATTACHED_CARD:
      return {
        ...state,
        loadingAttachedCard: true,
        attachedCard: null,
      };
    case GET_ATTACHED_CARD_SUCCESS:
      return {
        ...state,
        loadingAttachedCard: false,
        attachedCard: action.result,
      };
    case GET_ATTACHED_CARD_FAIL:
      return {
        ...state,
        loadingAttachedCard: false,
        attachedCard: null,
        attachedCardError: action.error,
      };
    default:
      return state;
  }
}

export const getAttachedCard = (bindingId) => ({
  actions: [
    { type: GET_ATTACHED_CARD },
    { type: GET_ATTACHED_CARD_SUCCESS },
    { type: GET_ATTACHED_CARD_FAIL },
  ],
  promise: fetchAttachedCard(bindingId),
});
